import React, { useState } from 'react';
import { XIcon, LockIcon } from 'lucide-react';
interface PasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}
export const PasswordModal = ({
  isOpen,
  onClose,
  onSuccess
}: PasswordModalProps) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === '9908') {
      setPassword('');
      setError('');
      onSuccess();
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };
  const handleClose = () => {
    setPassword('');
    setError('');
    onClose();
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-127">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative" data-id="element-128">
        <button onClick={handleClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-129">
          <XIcon className="h-6 w-6" data-id="element-130" />
        </button>
        <div className="flex flex-col items-center mb-6" data-id="element-131">
          <div className="h-16 w-16 rounded-full bg-gradient-to-br from-[#7FE5A8] to-[#5FD88F] flex items-center justify-center mb-4" data-id="element-132">
            <LockIcon className="h-8 w-8 text-[#1A2332]" data-id="element-133" />
          </div>
          <h2 className="text-2xl font-bold text-[#1A2332] mb-2" data-id="element-134">
            Enter Password
          </h2>
          <p className="text-gray-600 text-center" data-id="element-135">
            Please enter the password to edit the roadmap
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-136">
          <div data-id="element-137">
            <input type="password" value={password} onChange={e => {
            setPassword(e.target.value);
            setError('');
          }} placeholder="Enter password" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#7FE5A8] focus:border-transparent transition-all" autoFocus data-id="element-138" />
            {error && <p className="text-red-500 text-sm mt-2 flex items-center" data-id="element-139">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-red-500 mr-2" data-id="element-140"></span>
                {error}
              </p>}
          </div>
          <div className="flex gap-3" data-id="element-141">
            <button type="button" onClick={handleClose} className="flex-1 px-6 py-3 border-2 border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all" data-id="element-142">
              Cancel
            </button>
            <button type="submit" className="flex-1 px-6 py-3 bg-gradient-to-r from-[#7FE5A8] to-[#5FD88F] text-[#1A2332] rounded-xl font-semibold hover:shadow-lg transition-all" data-id="element-143">
              Unlock
            </button>
          </div>
        </form>
      </div>
    </div>;
};